var jade = require("/build/customer-ui/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<span ng-click=\"paypalCheckout()\" style=\"width:100%;height:100%;display:block;\" class=\"paypal-click-trigger\"><span ng-transclude></span></span>");;return buf.join("");
}


// WEBPACK FOOTER //
// ./source/client/layout-components/paypal-payment/paypal-payment.jade